import { Directive, Input, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { cpfValidator } from '../validators/cpf.validator';

@Directive({
  selector: '[cpfValidador]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CpfValidadorDirective),
      multi: true
    }
  ]
})
export class CpfValidadorDirective implements Validator {
  @Input() cpfValidador: any;

  validate(control: AbstractControl): ValidationErrors | null {
    return cpfValidator(control);
  }
}
